import { Injectable } from '@angular/core';

export interface IVideoConsumptionAttributes {
  videoUrl: string;
  timestamp: number;
  volume: number;
}

@Injectable()
export class EpicShowService {
  private videoAttributesMap: {
    [key: string]: IVideoConsumptionAttributes | undefined;
  } = {};

  public upsertVideoConsumptionAttributes(attr: IVideoConsumptionAttributes) {
    this.videoAttributesMap[attr.videoUrl] = {
      ...this.videoAttributesMap[attr.videoUrl],
      ...attr,
    };
  }

  public getVideoConsumptionAttributes(videoUrl: string) {
    return this.videoAttributesMap[videoUrl];
  }

  public clearVideoConsumptionAttributes(videoUrl: string) {
    delete this.videoAttributesMap[videoUrl];
  }
}
